
import { Options, Vue } from 'vue-class-component';
import {
  Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot,
} from '@headlessui/vue';
import { CheckIcon } from '@heroicons/vue/outline';
import SelectMenu from '@/components/SelectMenu.vue';
import Months from '@/data/months';
import { getAuth, sendPasswordResetEmail } from 'firebase/auth';

@Options({
  components: {
    Dialog,
    DialogOverlay,
    DialogTitle,
    TransitionChild,
    TransitionRoot,
    CheckIcon,
    SelectMenu,
  },
  props: {
    open: Boolean,
    editingItem: {
      name: String, year: String, location: String, date: Date,
    },
    slug: String,
  },
  emits: [
    'closed',
    'confirm',
  ],
})
export default class ForgotPasswordModal extends Vue {
  email = '';

  close() {
    this.$emit('closed');
  }

  confirm() {
    const auth = getAuth();
    sendPasswordResetEmail(auth, this.email)
      .then(() => {
        this.$emit('confirm');
      })
      .catch((error) => {
        this.$emit('confirm');
        const errorCode = error.code;
        const errorMessage = error.message;
      });
  }
}
